import clsx from "clsx";
import { Dayjs } from "dayjs";
import dayjs from "dayjs";
import React, { FC } from "react";
import { getAllowedDates } from "./datePickerUtils";

interface DayViewProps {
  current: Dayjs;
  onDateClick: (day: Dayjs) => void;
  selectedDate: dayjs.Dayjs;
}

const DayView: FC<DayViewProps> = ({ current, onDateClick, selectedDate }) => {
  const allowedDates = getAllowedDates();
  const isAllowedDate = allowedDates.some((date) => date.isSame(current, "day"));
  const isDisabled = !isAllowedDate;
  const isSelected = current.isSame(selectedDate, "day") && !isDisabled;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDisabled) {
      onDateClick(current);
    }
  };

  return (
    <button
      id={clsx({ "selected-date": isSelected })}
      onClick={handleClick}
      type="button"
      disabled={isDisabled}
      aria-label={`${current.format("dddd, MMMM D")}`}
      className={clsx("cb-date-day-item", {
        ["cb-selected"]: isSelected,
        ["cb-disabled-dates"]: isDisabled,
      })}
    >
      <div className="cb-date-label">{current.format("D")}</div>
      <div className="cb-day-label">{current.format("ddd")}</div>
    </button>
  );
};

export default DayView;
